import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { PickupMonitorActionButtonIcon, PickupMonitorActionButtonText, PickupMonitorActionButtonWrap } from './index.styled'
import MainIcon from '../../../../../../img/svg/main'
import { getActionButtonData } from './helper'
import Loader from '../../../../../Elements/loaders'

const PickupMonitorActionButton = React.memo(({ isUnpaidOrder, status, onClick, buttonType, disabled, isOrderStatusUpdating }) => {
	const { t } = useTranslation()
	const buttonData = getActionButtonData(isUnpaidOrder, status, t)
	const layout = (disabled ? 'disabled ' : '') + buttonData?.className

	const handleOnClick = useCallback(() => {
		if (disabled) return
		onClick(buttonData.updatableStatus, buttonType)
	}, [onClick, buttonData, disabled, buttonType])

	return (
		<PickupMonitorActionButtonWrap type="button"
																	 onClick={handleOnClick}
																	 className={layout}
																	 disabled={disabled}>
			{isOrderStatusUpdating ? <Loader color={status === 'PROCESSING_PICKUP' ? 'gray' : ''} /> : <>
				<PickupMonitorActionButtonText className={layout}>
					{buttonData?.text}
				</PickupMonitorActionButtonText>
				<PickupMonitorActionButtonIcon className={layout}>
					<MainIcon icon={buttonData?.icon} />
				</PickupMonitorActionButtonIcon></>}
		</PickupMonitorActionButtonWrap>
	)
})

PickupMonitorActionButton.displayName = 'PickupMonitorActionButton'
export default PickupMonitorActionButton
